/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import get from 'lodash.get';
import { z } from 'zod';
import { ValidationFailedError, DataValueNotFoundError } from '../errors.js';
import { BaseOperator } from './helpers.js';
import { CompanySanctionsCategoriesSchema } from './schemas.js';
import { OPERATION } from './enums.js';

var CompanySanctionsCategories = /*#__PURE__*/function (_BaseOperator) {
  function CompanySanctionsCategories() {
    return _BaseOperator.call(this, {
      operator: OPERATION.COMPANY_SANCTIONS_CATEGORIES,
      conditionValueSchema: CompanySanctionsCategoriesSchema
    }) || this;
  }
  _inheritsLoose(CompanySanctionsCategories, _BaseOperator);
  var _proto = CompanySanctionsCategories.prototype;
  _proto.extractValue = function extractValue(data, rule) {
    var companySanctionsSchema = z.object({
      pluginsOutput: z.object({
        companySanctions: z.object({
          data: z.array(z.object({
            entity: z.object({
              sources: z.array(z.object({
                categories: z.array(z.string())
              })).optional()
            }).optional()
          })).optional()
        })
      })
    });
    var result = companySanctionsSchema.safeParse(data);
    if (!result.success) {
      throw new ValidationFailedError('Extract value', 'parsing failed', result.error);
    }
    var objData = result.data;
    var companySanctions = get(objData, 'pluginsOutput.companySanctions.data');
    if (!companySanctions) {
      throw new DataValueNotFoundError('pluginsOutput.companySanctions.data');
    }
    var sourceCategories = [];
    companySanctions.forEach(function (sanction) {
      var _sanction$entity;
      if (sanction != null && (_sanction$entity = sanction.entity) != null && _sanction$entity.sources) {
        sanction.entity.sources.forEach(function (source) {
          if (source != null && source.categories && Array.isArray(source.categories)) {
            source.categories.forEach(function (category) {
              sourceCategories.push(category);
            });
          }
        });
      }
    });
    return sourceCategories;
  };
  _proto.evaluate = function evaluate(dataValue, conditionValue) {
    if (!dataValue || dataValue.length === 0) {
      return false;
    }
    var threshold = (conditionValue == null ? void 0 : conditionValue.threshold) || 1;
    var categoryCount = dataValue.filter(function (category) {
      return typeof category === 'string' && category.toLowerCase() === conditionValue.category.toLowerCase();
    }).length;
    return categoryCount >= threshold;
  };
  return CompanySanctionsCategories;
}(BaseOperator);
var COMPANY_SANCTIONS_CATEGORIES = new CompanySanctionsCategories();

export { COMPANY_SANCTIONS_CATEGORIES };
//# sourceMappingURL=company-sanctions-by-category.js.map
